import type {
  StatTypeRequestData,
  StatTypesQueryParams,
  StatTypesResponse
} from '@library/types/statType';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';

const { admin } = apiPaths;

export const statTypesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getStatTypes: build.query<StatTypesResponse, StatTypesQueryParams>({
      query: ({
        fromDate,
        leagueId,
        searchValue,
        sortBy,
        sortDir,
        page,
        perPage,
        toDate
      }) => ({
        url: `${admin}models/stat_types`,
        method: 'GET',
        params: {
          league_id: leagueId,
          page,
          per_page: perPage,
          'q[name_cont]': searchValue,
          'q[created_at_gteq]': fromDate,
          'q[created_at_lteq]': toDate,
          sort_by: sortBy,
          sort_dir: sortDir
        },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      })
    }),
    createStatType: build.mutation<StatTypesResponse, StatTypeRequestData>({
      query: (newStatTypeData) => ({
        url: `${admin}models/stat_types`,
        method: 'POST',
        body: { stat_type: newStatTypeData },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      transformErrorResponse: (response) => response.data
    }),
    updateStatType: build.mutation<
      StatTypesResponse,
      { id: string; data: StatTypeRequestData }
    >({
      query: ({ id, data }) => ({
        url: `${admin}models/stat_types/${id}`,
        method: 'PATCH',
        body: { stat_type: data },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      transformErrorResponse: (response) => response.data
    }),
    deleteStatType: build.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `${admin}models/stat_types/${id}`,
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      transformErrorResponse: (response) => response.data
    })
  })
});

export const {
  useGetStatTypesQuery,
  useCreateStatTypeMutation,
  useUpdateStatTypeMutation,
  useDeleteStatTypeMutation
} = statTypesApi;
